// extracted by mini-css-extract-plugin
export default {"migration_wrapper":"migration_wrapper___QOJ01"};